var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"file-name-card",on:{"click":function($event){return _vm.fecthVersionData(_vm.file)}}},[_c('span',{directives:[{name:"overflow-tooltip",rawName:"v-overflow-tooltip"}],staticClass:"weight-500 l elipsis-text"},[_vm._v(" "+_vm._s(_vm.file.doc_name)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }